import CasLink2 from 'src/compass/shared/components/CasLink/CasLink2';
import useSiteProperties from '../general/hooks/useSiteProperties';

interface IProps {
  id: number;
  recordPath?: string;
}

export default function HubspotLink({ id, recordPath }: IProps) {
  const { data } = useSiteProperties();

  return (
    <CasLink2
      href={`${data?.hubspotBaseUrl}/${recordPath}/${id}`}
      icon="mdi:hubspot"
      target="_blank"
      rel="noopener noreferrer"
      style={{ visibility: id ? 'visible' : 'hidden' }}
    />
  );
}
